import { pickT } from "@repo/shared";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { T } from "./portfolio-forecast-config-form.i18n";

type PortfolioForecastConfigFormProps = {
  flowLanguage: string;
  showStatistics: boolean;
  onShowStatisticsChange: (show: boolean) => void;
  showTable: boolean;
  onShowTableChange: (show: boolean) => void;
};

export function PortfolioForecastConfigForm({
  flowLanguage,
  showStatistics,
  onShowStatisticsChange,
  showTable,
  onShowTableChange,
}: PortfolioForecastConfigFormProps) {
  const t = pickT(T, flowLanguage);

  return (
    <div className="space-y-4 border rounded-lg p-4 bg-muted/30">
      <div className="space-y-2">
        <Label className="text-base">{t.displayOptions}</Label>
        <p className="text-sm text-muted-foreground">{t.displayDesc}</p>
      </div>

      <div className="flex items-center justify-between">
        <div>
          <Label htmlFor="forecast-show-statistics" className="text-base">
            {t.showStatistics}
          </Label>
          <p className="text-sm text-muted-foreground">{t.statisticsDesc}</p>
        </div>
        <Switch
          id="forecast-show-statistics"
          checked={showStatistics}
          onCheckedChange={onShowStatisticsChange}
        />
      </div>

      <div className="flex items-center justify-between">
        <div>
          <Label htmlFor="forecast-show-table" className="text-base">
            {t.showTable}
          </Label>
          <p className="text-sm text-muted-foreground">{t.tableDesc}</p>
        </div>
        <Switch id="forecast-show-table" checked={showTable} onCheckedChange={onShowTableChange} />
      </div>
    </div>
  );
}
